export default function (string) {
    return string.replace(/(?:\r\n|\r|\n)/g, '<br>')
}